module.exports = __webpack_public_path__ + "static/021_Gippsland_banner-864810fcc945ead24d672a06d731c33f.jpg";